import { action } from 'mobx'
import ListStore from '../../../shared-lib/stores/ListStore'
import SmsCampaignModel from './SmsCampaignModel'

export type $SmsCampaignStore = SmsCampaignStore

export default class SmsCampaignStore extends ListStore<SmsCampaignModel> {
  fetchMethodName = 'smsCampaigns'
  ModelClass = SmsCampaignModel

  @action.bound async createSmsCampaign_api(data: CreateSmsCampaignInput, showConfirmationMessage = true) {
    const { communication: { requester }, dropdownMessageHandler: { showDropdownMessage } } = this.rootStore

    this.setLoading(true)
    try {
      const { createSmsCampaign } = await requester.createSmsCampaign({ data })
      this.mergeData([createSmsCampaign])

      if (showConfirmationMessage) {
        showDropdownMessage({
          title: 'Campaign created successfully.',
          type: 'success',
        })
      }
      return createSmsCampaign
    } catch (e) {
      return false
    } finally {
      this.setLoading(false)
    }
  }

  @action.bound async updateSmsCampaign_api(data: UpdateSmsCampaignInput) {
    const { communication: { requester } } = this.rootStore

    this.setLoading(true)

    delete (data as SmsCampaign).lastSentAt

    try {
      const { updateSmsCampaign } = await requester.updateSmsCampaign({ data })
      this.mergeData([updateSmsCampaign])
      return updateSmsCampaign
    } catch (e) {
      return
    } finally {
      this.setLoading(false)
    }
  }

  @action setEditItem = (data: SmsCampaignModel['data']) => {
    this.originalEditItemData = { ...data }
    this.editItem = new this.ModelClass(data, this.rootStore) as SmsCampaignModel

    const existingCampaign = this.findItemById(data._id)
    if (existingCampaign) {
      this.editItem.automatedCampaignData = existingCampaign.automatedCampaignData
    }
  }
}
